// Confirmation dialog — used for revoke actions

import type { ReactNode } from "react";

interface ConfirmDialogProps {
	open: boolean;
	title: string;
	children: ReactNode;
	confirmLabel?: string;
	confirmVariant?: "danger" | "primary";
	onConfirm: () => void;
	onCancel: () => void;
}

export function ConfirmDialog({
	open,
	title,
	children,
	confirmLabel = "Confirm",
	confirmVariant = "primary",
	onConfirm,
	onCancel,
}: ConfirmDialogProps) {
	if (!open) return null;

	return (
		<div className="dialog-overlay" onClick={onCancel}>
			<div className="dialog" onClick={(e) => e.stopPropagation()}>
				<div className="dialog-title">{title}</div>
				<div>{children}</div>
				<div className="dialog-actions">
					<button className="btn" onClick={onCancel} type="button">
						Cancel
					</button>
					<button
						className={`btn ${confirmVariant === "danger" ? "btn-danger" : "btn-primary"}`}
						onClick={onConfirm}
						type="button"
					>
						{confirmLabel}
					</button>
				</div>
			</div>
		</div>
	);
}
